import { Component, EventEmitter, Input, OnChanges, OnInit } from '@angular/core';
import { ArrayUtils } from "../../../common/providers/array-utils";
import { EvaluationAthleteQuestionProvider } from '../../providers/evaluation-athlete-question-provider.services';
import { EvaluationAthlete } from "../../../common/models/evaluation-athlete";
import { MatCard, MatCardModule } from "@angular/material/card";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SpiderChartComponent } from "../spider-chart/evaluation-athlete-spider-chart";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { Organization } from "../../../common/models/organization";
import { NgIf } from "@angular/common";

@Component({
  selector: 'evaluation-athlete-result',
  providers: [],
  styleUrls: ['./evaluation-athlete-result.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    FlexLayoutModule,
    SpiderChartComponent,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    AppDatePipe,
    NgIf
  ],
  templateUrl: './evaluation-athlete-result.html'
})
export class EvaluationAthleteResultComponent implements OnInit, OnChanges {

    @Input()
    public organization: Organization = {} as Organization;

    @Input()
    public evaluationAthlete: EvaluationAthlete = {} as EvaluationAthlete;

    @Input()
    public selectedEvaluations$ = new EventEmitter<Set<any>>();

    @Input()
    public selectedEvaluationsEvent$ = new EventEmitter<string>();

    @Input()
    public isDesktop = true;

    public questionsGrouped: any[] = [];

    public athleteLastUpdateDate: Date | null = null;
    public coachLastUpdateDate: Date | null = null;

    constructor(
        private evaluationAthleteQuestionProvider: EvaluationAthleteQuestionProvider,
        private arrayUtils: ArrayUtils,
    ) {
    }

    public ngOnInit() {
        this.loadData();
    }

    public ngOnChanges() {
      this.loadData();
    }

    public loadData() {
      this.evaluationAthleteQuestionProvider.findByEvaluationAthleteId(this.organization.id!, this.evaluationAthlete.id!).subscribe({
        next: (questions) => {
          this.questionsGrouped = this.arrayUtils.groupByAttribute(questions, 'category', 'name');
          this.athleteLastUpdateDate = (this.evaluationAthlete.answers?.length??0) > 0 ? new Date(Math.max(...(this.evaluationAthlete.answers?.map((e: any) => e.updateDate)??[]))) : null;
        },
        error: (error) => {
          console.error('Error loading questions', error);
        }
      });
    }

    public onSelectNoneClicked() {
        this.selectedEvaluationsEvent$.emit('none');
    }

    public onSelectAllClicked() {
        this.selectedEvaluationsEvent$.emit('all');
    }
}
